// extracted by mini-css-extract-plugin
export var formContainer = "_gn-0";
export var message = "_gn-1";